import fetch from "logic/rest/FetchProvider";
import { reportingUrl } from "report/Constants";
export default (id, report) => {
  const { share_request, ...rest } = report;
  const payload = id ? report : { entity: rest, share_request };
  return fetch(id ? "PUT" : "POST", reportingUrl(id), payload);
};
